const Environment = {
    version: '1.0.0',
    // host: 'http://192.168.1.15:3010',
    host: 'https://etsy-api.llc-vn.com',

};
export default Environment;
